import { Link } from 'react-router-dom';
import styles from './RouteBar.module.css';

// function RouteBar({ heading, links = [] }) {
//   return (
//     <div className="breadcrumb-area">
//         <div className="container-fluid">
//           <div className="row pt-1 pb-1">
//             <div className="col-md-6 col-6">
//               <nav aria-label="breadcrumb">
//                 <h2  style={{ fontSize: "25px" }} className={`${styles.heading}`}>{heading}</h2>
//               </nav>
//             </div>
//             <div className="col-md-6 col-6 d-flex justify-content-center align-items-center d-lg-block">
//               <ol className={`${styles.list} breadcrumb d-flex justify-content-end bg-transparent`}>
//                 <li className={`${styles.listItem} breadcrumb-item`}>
//                   <Link to="/Dashboard">Dashboard</Link>
//                 </li>
//                 {
//                   (Array.isArray(links) && links.length > 0) && links.map((link, index) => {
//                     return (
//                       <li className={`${styles.listItem} breadcrumb-item`} key={index}>
//                         <Link to={link.href}>{link.text}</Link>
//                       </li>
//                     )
//                   })
//                 }
                
//                 {
//                   (Array.isArray(links) && links.length === 0) && (
//                     <li className={`breadcrumb-item active ${styles.listItem}`} aria-current="page">
//                       { heading }
//                     </li>
//                   )
//                 }
//               </ol>
//             </div>
//           </div>
//         </div>
//       </div>
//   )
// }
function RouteBar({ heading, links = [] }) {
  return (
    <div className="breadcrumb-area">
      <div className="container-fluid">
        <div className="row pt-1 pb-1">
          
          {/* LEFT SIDE */}
          <div className="col-md-6 col-6">
            <nav aria-label="breadcrumb">
              <h2 style={{ fontSize: "25px" }} className={`${styles.heading}`}>
                {heading}
              </h2>

             
              {/* {(year || financialYear) && (
                <div style={{ fontSize: "14px", color: "#666" }}>
                  {year && <span>Year: {year}</span>}
                  {year && financialYear && " | "}
                  {financialYear && <span>FY: {financialYear}</span>}
                </div>
              )} */}
            </nav>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-md-6 col-6 d-flex justify-content-center align-items-center d-lg-block">
            <ol className={`${styles.list} breadcrumb d-flex justify-content-end bg-transparent`}>
              <li className={`${styles.listItem} breadcrumb-item`}>
                <Link to="/Dashboard">Dashboard</Link>
              </li>

              {Array.isArray(links) && links.length > 0 &&
                links.map((link, index) => (
                  <li className={`${styles.listItem} breadcrumb-item`} key={index}>
                    <Link to={link.href}>{link.text}</Link>
                  </li>
                ))}

              {Array.isArray(links) && links.length === 0 && (
                <li className={`breadcrumb-item active ${styles.listItem}`} aria-current="page">
                  {heading}
                </li>
              )}
            </ol>
          </div>

        </div>
      </div>
    </div>
  );
}
export default RouteBar
